import { map } from 'rxjs/operators';
import { AsyncPipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';
import { StrHlp } from 'src/lib/fliko/helpers/string.helper';
import { DefectData } from 'src/lib/fliko/models/defects/defect.data';
import { DefectType } from 'src/lib/fliko/models/defects/defect-settings.data';
import { LocalizationService } from 'src/app/shared/services/localization.service';
import { DefectTypeTranslator } from 'src/app/view/defects/helpers/defect-type-translator';
import { DefectDataService } from 'src/app/view/defects/service/defect-data.service';

@Pipe({ name: 'defectType', pure: false })
export class DefectTypePipe implements PipeTransform {
  private dtt$ = this.defectDS.getDefaultDefectTypes$().pipe(map((types) => new DefectTypeTranslator(types, this.ls)));

  constructor(
    private defectDS: DefectDataService,
    private asyncPipe: AsyncPipe,
    private ls: LocalizationService
  ) {}

  public transform(value: DefectData | DefectType | string | null | undefined, placeholder: string = ''): string {
    const translator = this.asyncPipe.transform(this.dtt$);
    let typeHr = '';

    if (value) {
      // ! Sometimes asyncPipe returns null
      if (translator) {
        if (value.hasOwnProperty('typeId')) typeHr = translator.fromDefect(value as DefectData);
        else if (value.hasOwnProperty('label')) typeHr = translator.fromType(value as DefectType);
        else if (StrHlp.isString(value)) typeHr = translator.fromId(value as string);
      } else typeHr = value.toString();
    }

    return typeHr || placeholder;
  }
}
